import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(t, e) {
  return o(), l("svg", a, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.595 6.577a1 1 0 0 0 0 2h2.65l-6.766 6.766a1 1 0 0 0 1.414 1.414l6.743-6.743v2.604a1 1 0 1 0 2 0V7.577a1 1 0 0 0-1-1zM8.476 17.535a1 1 0 1 0 0-2h-2.65l6.766-6.766a1 1 0 0 0-1.414-1.414l-6.743 6.743v-2.604a1 1 0 0 0-2 0v5.041a1 1 0 0 0 1 1zM2.487 2.349a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414M16.655 16.237a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.415 1.414l-4-4a1 1 0 0 1 0-1.414",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const c = { render: n };
export {
  c as default,
  n as render
};
//# sourceMappingURL=ic_border_crossing-BdPetWBe.js.map
